import { Component, OnDestroy, OnInit } from '@angular/core';
import { Staff } from 'src/app/models/staff.model';
import { ShowcaseService } from 'src/app/services/header-showcase/showcase.service';

@Component({
    selector: 'app-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit, OnDestroy {

    administration: Staff[] = [
        { name: 'Dr. Arvinder Singh Bhalla', img: '/assets/img/about-us/administration/1.png', position: 'Principal (9463062603)' },
        { name: 'Dr. Amarjit Singh', img: '/assets/img/about-us/administration/2.jpg', position: 'Registrar (9896239977)' },
        { name: 'Dr. Rajinder Singh Vohra', img: '/assets/img/about-us/administration/3.jpg', position: 'Assistant Professor (8708826198)' }
    ];

    constructor(private showcaseService: ShowcaseService) {
        this.showcaseService.hideShowcase();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.showcaseService.showingShowcase();
    }

}
